import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';
import { useTranslation } from 'react-i18next';

function Header({ toggleSidebar, sidebarOpen, showToast }) {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();
  const { clearSampleData } = useData();
  const { t, i18n } = useTranslation();

  const handleLogout = () => {
    if (window.confirm(t('auth.logout') + '?')) {
      logout();
      navigate('/login');
    }
  };

  const toggleLanguage = () => {
    const newLang = i18n.language === 'vi' ? 'en' : 'vi';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  const handleClearSampleData = () => {
    const confirmed = window.confirm(
      'Bạn có chắc muốn xóa dữ liệu mẫu?\n\nThao tác sẽ reset danh sách khách hàng/mô hình/cảnh báo về dữ liệu mặc định và xóa cases/rules đã tạo.'
    );

    if (!confirmed) return;

    clearSampleData();
    showToast && showToast('✅ Đã clear dữ liệu mẫu thành công!', 'success');
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="btn btn-link text-white sidebar-toggle" onClick={toggleSidebar}>
          <i className={`bi ${sidebarOpen ? 'bi-list' : 'bi-list'}`}></i>
        </button>
        <h4 className="mb-0 ms-2">
          <i className="bi bi-shield-check me-2"></i>
          EWS - {t('dashboard.subtitle')}
        </h4>
      </div>
      <div className="header-right">
        <div className="header-language me-3">
          <button 
            className="btn btn-link text-white d-flex align-items-center"
            onClick={toggleLanguage}
            title={i18n.language === 'vi' ? 'Switch to English' : 'Chuyển sang Tiếng Việt'}
          >
            <i className="bi bi-translate fs-5 me-1"></i>
            <span className="fw-bold">{i18n.language.toUpperCase()}</span>
          </button>
        </div>
        <div className="header-notifications me-3">
          <button className="btn btn-link text-white position-relative">
            <i className="bi bi-bell fs-5"></i>
            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
              3
            </span>
          </button>
        </div>
        <div className="header-user dropdown">
          <button className="btn btn-link text-white dropdown-toggle" type="button" data-bs-toggle="dropdown">
            <i className="bi bi-person-circle fs-5 me-2"></i>
            <span>{currentUser?.name || 'User'}</span>
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li>
              <div className="dropdown-item-text">
                <small className="text-muted">{currentUser?.email}</small><br/>
                <small className="text-muted">
                  <i className="bi bi-shield-check me-1"></i>
                  {currentUser?.role}
                </small>
              </div>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li>
              <button 
                className="dropdown-item"
                onClick={() => navigate('/profile')}
              >
                <i className="bi bi-person me-2"></i>Thông tin cá nhân
              </button>
            </li>
            <li>
              <button 
                className="dropdown-item"
                onClick={() => navigate('/change-password')}
              >
                <i className="bi bi-key me-2"></i>Đổi mật khẩu
              </button>
            </li>
            <li>
              <button
                className="dropdown-item text-danger"
                onClick={handleClearSampleData}
              >
                <i className="bi bi-trash3 me-2"></i>Clear dữ liệu mẫu
              </button>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li>
              <button className="dropdown-item text-danger" onClick={handleLogout}>
                <i className="bi bi-box-arrow-right me-2"></i>{t('auth.logout')}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
